import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface StatCardProps {
  title: string;
  value: string | number;
  icon: BoxIcon;
  trend?: string;
  trendDirection?: 'up' | 'down' | 'neutral';
  accentColor?: 'navy' | 'red' | 'green' | 'amber';
  delay?: number;
}
export function StatCard({
  title,
  value,
  icon: Icon,
  trend,
  trendDirection = 'neutral',
  accentColor = 'navy',
  delay = 0
}: StatCardProps) {
  const borderColors = {
    navy: 'border-l-navy-900',
    red: 'border-l-red-500',
    green: 'border-l-emerald-500',
    amber: 'border-l-amber-500'
  };
  const iconColors = {
    navy: 'text-navy-900 bg-navy-50',
    red: 'text-red-600 bg-red-50',
    green: 'text-emerald-600 bg-emerald-50',
    amber: 'text-amber-600 bg-amber-50'
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4,
    delay
  }} className={`bg-white rounded-lg shadow-sm p-6 border-l-4 ${borderColors[accentColor]}`} data-id="element-299">
      <div className="flex items-center justify-between" data-id="element-300">
        <div data-id="element-301">
          <p className="text-sm font-medium text-slate-500 truncate" data-id="element-302">{title}</p>
          <div className="mt-2 flex items-baseline" data-id="element-303">
            <p className="text-2xl font-bold text-navy-900" data-id="element-304">{value}</p>
          </div>
        </div>
        <div className={`p-3 rounded-lg ${iconColors[accentColor]}`} data-id="element-305">
          <Icon className="h-6 w-6" data-id="element-306" />
        </div>
      </div>
      {trend && <div className="mt-4 flex items-center text-sm" data-id="element-307">
          <span className={`font-medium ${trendDirection === 'up' ? 'text-emerald-600' : trendDirection === 'down' ? 'text-red-600' : 'text-slate-500'}`} data-id="element-308">
            {trend}
          </span>
          <span className="text-slate-400 ml-2" data-id="element-309">vs. mês anterior</span>
        </div>}
    </motion.div>;
}